import React from 'react';
import { Question, FileReports } from '@ch/common/types/data';

export enum fieldGroups {
  TYPE = 'type',
  FORM = 'form',
  CONFIRM = 'confirm',
  // sub field groups
}

export enum subFieldGroups {
  INFO = 'info_label',
  GENERAL = 'general_info_label',
  EVENT = 'event_info_label',
  PRODUCT = 'product_info_label',
  PATIENT = 'patient_info_label',
  REPORT = 'report_info_label',
  DOC = 'doc_info_label',
  ADDITIONAL_INFO = 'additional_information_section',
}

export type FieldGroupDataItem = {
  icon?: React.ElementType;
  nav?: string;
  title?: string;
  questions?: Question[];
  question?: Question;
  fullWidth?: boolean;
  customLayout?: boolean;
  subNav?: FieldGroupsData;
};

export type FieldGroupsData = {
  [key in fieldGroups]?: FieldGroupDataItem;
};

export type AnnotationData = {
  alternativeText: string;
  annotationFlags: any;
  annotationType: number;
  buttonValue: any;
  borderStyle: {
    width: number;
    style: number;
    dashArray: any[];
    horizontalCornerRadius: number;
    verticalCornerRadius: number;
  };
  color: number[];
  combo: boolean;
  checkBox: boolean;
  defaultAppearance: string;
  fieldFlags: number;
  fieldName: string;
  fieldType: string;
  fieldValue: any;
  options: any;
  hasAppearance: boolean;
  id: string;
  maxLen: null | number;
  multiLine: boolean;
  readOnly: boolean;
  rect: number[];
  subtype: string;
  textAlignment: number;
  toolTip: string;
};

export type AnnotationField = {
  $width: number;
  $height: number;
  $top: number;
  $left: number;
};

export enum FileOptionsSelect {
  FILE_TYPE = 'fileType',
  FILE_REPORT = 'fileReport',
}

export type FileOptions = {
  [key in FileOptionsSelect]?: {
    title: string;
    options: {
      label: string;
      value: string;
    }[];
    descriptions?: FileReports[];
  };
};
export const fileOptionsSelectArray = Object.values(FileOptionsSelect) as string[];

export interface QuestionDocuments {
  [questionId: string]: Document[];
}

export type Document = {
  url: string;
  file: File;
  values: { [FileOptionsSelect.FILE_REPORT]: string; [FileOptionsSelect.FILE_TYPE]: string };
};

export type DropdownData = {
  [file: string]: {
    displayedOptions: { value: string; label: string }[];
    rawOptions: Record<string, unknown>[];
  };
};
